import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";

export function Breadcrumbs({ items }) {
  if (!items || items.length <= 1) return null;
  return (
    <nav
      data-testid="breadcrumbs"
      aria-label="Breadcrumb"
      className="mx-auto flex max-w-3xl flex-wrap items-center gap-1 px-4 pt-4 text-xs text-slate-500"
    >
      {items.map((b, i) => (
        <span key={b.path} className="flex items-center gap-1">
          {i < items.length - 1 ? (
            <Link to={b.path} className="hover:text-[#1ab5a3]">
              {b.name}
            </Link>
          ) : (
            <span className="font-semibold text-slate-700">{b.name}</span>
          )}
          {i < items.length - 1 && <ChevronRight size={13} />}
        </span>
      ))}
    </nav>
  );
}

export default function Layout({ children }) {
  return (
    <div className="App flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
